"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemStyles = void 0;
const tslib_1 = require("tslib");
const polished_1 = require("polished");
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
exports.itemStyles = (0, styled_components_1.css) `
  border: none;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 ${(0, polished_1.rem)(12)};
`;
exports.default = styled_components_1.default.div `
  ${exports.itemStyles}
`;
